/**
 * vars 模块
 * @description 全局通用变量
 *              production块内是线上入口url
 *              else 块内是dev url
 */


// 全局引用jquery
// import 'jquery'
// import 'zepto'

let vars = {}

if (process.env.NODE_ENV === 'production') {
    vars = {
        index: '/'
    }
} else {
    vars = {
        index: '/index.html'
    }
}
vars.hideOpencourse = false
vars.showWhatsnew = true
vars.peekTicketName = '瞻仰'
// vars.navlv1number = {
// 	home: 0,
// 	course: 1,
// 	discover: 2,
// 	message: 3,
// 	myself: 4
// }
vars.navlv1number = {
    course: 0,
    discover: 1,
    message:2,
    myself: 3
}

if(vars.hideOpencourse){
    vars.navlv1number = {
        course: 0,
        myself: 1
    }
}

vars.external_path ={
    "quiz_result":"/quiz/quiz_result",
    "quiz_info":"/quiz/quiz_info",
    "cards_info":"/cards/cards_info",
    "lesson_info":"/v/lesson/lesson_info",
    "lesson_student": "/lesson/student",
    "lesson_teacher": "/lesson/teacher",
    "links_info":"/v/link/links_info",
    "manage_memo":"/v/memo/manage_memo"
}

export default vars



// WEBPACK FOOTER //
// ./src/util/vars.js